var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"aliceblue"}},[_c('div',{},_vm._l((_vm.svgSFunsLIst),function(i,index){return _c('svg',{staticClass:"svg-icon imageWrap",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#'+i}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }